import axios from 'axios'
import CommentModel from '@/services/Models/CommentModel'
import PlayerModel from '@/services/Models/PlayerModel'
import HitModel from '@/services/Models/HitModel'

export default {
  getList(config) {
    let url = (config && config.next_page_url) || '/hits'

    return axios.get(url, {
      params: {
        my_school: config && config.my_school,
        league: config && config.league,
        challenge: config && config.challenge
      }
    })
    .then(mapToHits)
  },

  getLatest() {
    return axios.get('/lastest-hits')
      .then(mapToHits)
  },

  getHit(id) {
    return axios.get('/hits/' + id)
      .then(mapToHit)
  },

  storeHit(data) {
    return axios.post('/hits', data)
            .then(mapToHit)
  },

  updateHit(hit_id, data) {
    return axios.put('/hits/' + hit_id, data)
            .then(mapToHit)
  },

  deleteHit(hit_id) {
    return axios.delete('/hits/' + hit_id)
  },

  getLikes(hit_id) {
    return axios.get('/hits/' + hit_id + '/likes')
            .then(mapToLikes)
  },

  toggleLike(hit_id) {
    return axios.post('/hits/' + hit_id + '/likes')
  },

  toggleTagLike(hit_id, tag_id) {
    return axios.post('/hits/' + hit_id + '/tags/' + tag_id + '/likes')
  },

  getNextComments(hit_id, next_link) {
    const url = next_link || '/hits/' + hit_id + '/comments'

    return axios.get(url)
            .then(mapToComments)
  },

  postComment(hit_id, content) {
    return axios.post('/hits/' + hit_id + '/comments', {content})
            .then(mapToComments)
  }
}

function mapToHit(response) {
  return HitModel(response.data)
}

function mapToHits(response) {
  if (response.data.data) {
    response.data.data = response.data.data.map(HitModel)
  } else {
    response.data = response.data.map(HitModel)
  }

  return response.data
}

function mapToComments(response) {
  if (response.data.data) {
    response.data.data = response.data.data.map(CommentModel)
  } else {
    response.data = CommentModel(response.data)
  }

  return response.data
}

function mapToLikes(response) {
  return response.data.map(like => {
    like.user.player = PlayerModel(like.user.player)

    return like
  })
}



// WEBPACK FOOTER //
// ./src/services/Api/HitApi.js